import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { DocumentRequest } from "../DocumentRequest";
import { RaffleIcon } from "../../../assets/image/RaffleIcon";
import { RebootIcon } from "../../../assets/image/RebootIcon";
import { ArrowLeftIcon } from "../../../assets/image/ArrowLeftIcon";
import {
  ENG_LANGUAGE,
  MONTH_ENG_LANGUAGE,
  MONTH_SRB_LANGUAGE,
  REFINE_OPTIONS,
} from "../../../utils/variables";
import {
  deleteMultiDocuments,
  getNotificationsDocument,
} from "../../../api/documentApi";
import { useInterviewStore } from "../../../store/useInterviewStore";
import { DocumentMessage } from "../DocumentMessage";

export function DocumentRequests({setProfileSection}) {
  const { t, i18n } = useTranslation();
  const language = i18n.language;
  const navigate = useNavigate();

  const [isCheck, setIsCheck] = useState(true);
  const [documentData, setDocumentData] = useState([]);
  const [view, setView] = useState("");
  const [deleteList, setDeleteList] = useState([]);
  const [recived, setRecived] = useState("");
  const [isActive, setIsActive] = useState(false);

  const { refine, setRefine, resetInterviewState } = useInterviewStore();

  useEffect(() => {
    return () => {
      resetInterviewState();
    };
  }, []);
  const slugdata = useParams();
  let data = slugdata.name;

  const month =
    language === ENG_LANGUAGE ? MONTH_ENG_LANGUAGE : MONTH_SRB_LANGUAGE;

  const fetchDocumentData = async () => {
    setDocumentData([]);

    try {
      const result = await getNotificationsDocument(refine);
      setDocumentData(result.data);
    } catch (error) {
      console.error("Error fetching document data:", error);
    }
  };

  useEffect(() => {
    if (isCheck) {
      fetchDocumentData();
      setIsCheck(false);
    }
    setView(data ? data : "");
  }, [isCheck, documentData, data, slugdata]);

  useEffect(() => {
    if (window.innerWidth < 768) {
      setRecived("text-refine");
    }
  }, []);

  const handleSelectElement = () => {
    const ele = document.getElementsByName("chk");
    documentData.map((data) => {
      deleteList.push(data.id);
    });
    for (let i = 0; i < ele.length; i++) {
      if (ele[i].type == "checkbox") ele[i].checked = true;
    }
  };

  const handleDeselectElement = () => {
    const ele = document.getElementsByName("chk");
    for (let i = 0; i < ele.length; i++) {
      if (ele[i].type == "checkbox") ele[i].checked = false;
    }
    setDeleteList([]);
  };

  const handleDeleteSelect = (a) => {
    let sum = false;
    deleteList.map((e) => {
      if (e == a) {
        sum = true;
        const index = deleteList.indexOf(a);
        if (index > -1) {
          deleteList.splice(index, 1);
        }
      }
    });
    if (sum == false) {
      deleteList.push(a);
    }
  };

  const handleDeleteMultiDocuments = async () => {
    try {
      const result = await deleteMultiDocuments(deleteList);
      fetchDocumentData();
    } catch (error) {
      console.error("Error deleting documents:", error);
    }
  };

  const handleRefineDay = (e) => {
    setRefine({
      threedays: e == "3" ? true : "",
      withinweek: e == "7" ? true : "",
      twofourday: e == "24" ? true : "",
      withinmonth: e == "30" ? true : "",
    });

    setIsCheck(true);
  };

  return (
    <div>
      {view == "" ? (
        <>
          <div className="main-header">
            <h2 className="border">{t("document-requests")}</h2>
            <div className="mail-header-bar">
              <p>
                {documentData.length} {t("text-requests")}
              </p>
              <div className="btn-group flex">
                {t("text-refine")}
                <div className="select">
                  <label onClick={(e) => setIsActive(!isActive)}>
                    {t(recived)}
                    <span>
                      <img src="/images/done_a.svg" />
                    </span>
                  </label>
                  {isActive && (
                    <ul>
                      {REFINE_OPTIONS.map((option) => (
                        <li
                          key={option.label}
                          onClick={() => {
                            setRecived(t(option.label));
                            handleRefineDay(option.value);
                            setIsActive(!isActive);
                          }}
                        >
                          {t(option.label)}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </div>
            <div className="mail-option">
              <div className="chk-all">
                <input
                  type="checkbox"
                  className="mail-radio mail-group-radio"
                  name="chk"
                  id="checkbox_id"
                  onClick={(e) => {
                    if (e.target.checked) {
                      handleSelectElement();
                    } else {
                      handleDeselectElement();
                    }
                  }}
                />
                <span className="circle"></span>
                <label for="checkbox_id">{t("select-all")}</label>
              </div>
              <div className="right-side-btn">
                <div
                  className="delete-btn"
                  onClick={(e) => handleDeleteMultiDocuments()}
                >
                  <a href="#">
                    <RaffleIcon />
                    <span> {t("text-delete")}</span>
                  </a>
                </div>
                <div
                  className="refresh-btn"
                  onClick={(e) => fetchDocumentData()}
                >
                  <a href="#">
                    <RebootIcon />
                  </a>
                  <span>{t("text-refresh")}</span>
                </div>
              </div>
            </div>
          </div>
          <table className="table table-inbox table-hover">
            <tbody>
              {documentData.map((data) => {
                return (
                  <DocumentMessage
                    month={month}
                    key={data.id}
                    data={data}
                    handleDeleteSelect={handleDeleteSelect}
                    setView={setView}
                    setProfileSection={setProfileSection}
                  />
                );
              })}
            </tbody>
          </table>
        </>
      ) : (
        <div className="main-header">
          <button
            onClick={(e) => {
              navigate("/search-providers/" + slugdata.id);
              setView("");
            }}
          >
            <ArrowLeftIcon />
            {t("text-back")}
          </button>
          <DocumentRequest id={view} />
        </div>
      )}
    </div>
  );
}
